module.exports = __webpack_public_path__ + "static/media/pw.ed295555.svg";